export default __webpack_public_path__ + "static/media/JP.6dc81604.svg";